import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const domSync = /*           */ asExport(o_util, "dom", {});
const stringToDocumentFragment = /*           */ asExport(domSync, "stringToDocumentFragment", noop);
const getFirstElementByTagName = /*           */ asExport(domSync, "getFirstElementByTagName", noop);
const getHeadElement = /*           */ asExport(
  domSync,
  "getHeadElement",
  noop
);
const getBodyElement = /*           */ asExport(
  domSync,
  "getBodyElement",
  noop
);
const domAsync = /*           */ asExport(otto, "dom", {});
const onLoad = /*           */ asExport(domAsync, "onLoad");
const onReady = /*           */ asExport(domAsync, "onReady");
const onMount = /*           */ asExport(domAsync, "onMount", noop);
const onUnmount = /*           */ asExport(domAsync, "onUnmount", noop);
const insertHtmlFragment = /*           */ asExport(
  domAsync,
  "insertHtmlFragment",
  noop
);
const activateInlineScripts = /*           */ asExport(
  domAsync,
  "activateInlineScripts",
  noop
);
export {
  activateInlineScripts,
  domAsync,
  domSync,
  getBodyElement,
  getFirstElementByTagName,
  getHeadElement,
  insertHtmlFragment,
  onLoad,
  onMount,
  onReady,
  onUnmount,
  stringToDocumentFragment
};
/*                                   */
